<section class="table-wrapper">
    <!-- This table cell is sortable using matSort -->
    <table mat-table matSort [dataSource]="tableData" class="mat-elevation-z0 bciti-table">

        <ng-container [matColumnDef]="tableDataKey" *ngFor="let tableDataKey of objectKeys(columnHeader)">
            <!-- This header cell is sortable using mat-sort-header -->
            <th mat-header-cell *matHeaderCellDef> {{columnHeader[tableDataKey]}} </th>
            <td mat-cell *matCellDef="let element"> 
                <span *ngIf="htmlProperties.includes(tableDataKey); else elseBlock">
                    <span class="mobile-label" [innerHTML]="columnHeader[tableDataKey] | safeHtml"></span>
                    <span [innerHTML]="element[tableDataKey] | safeHtml" class="icon-padding"></span>
                </span>

                <ng-template #elseBlock>
                    <span class="mobile-label">{{columnHeader[tableDataKey]}}</span>
                    {{element[tableDataKey] }}
                </ng-template>
            </td>
          </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="action-col">
                <button class="desktop-table-button bciti-button bciti-button--invisible" aria-label="Open"
                    [matMenuTriggerFor]="menu">
                    <i class="icon-more-vertical"></i>
                </button>
                <!-- ng-container *ngFor="let item of actionMenuData.options" >
                    <button 
                        class="mobile-table-button bciti-button" 
                        *ngIf="item.eventEmitterTag === 'details'"
                        (click)="handleClick(item.eventEmitterTag, element)">
                        {{item.label}}
                    </button>
                </ng-container -->
                <mat-menu #menu="matMenu" class="bciti-table-action-menu">
                    <div class="menu-heading">{{ actionMenuData.heading }}</div>
                    
                    <button 
                        class="bciti-table-action-button" 
                        *ngFor="let item of actionMenuData.options" 
                        (click)="handleClick(item.eventEmitterTag, element)">
                        <span>{{ item.label }}</span>
                    </button>

                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="addActionsColumn(objectKeys(columnHeader))" class="bciti-element-table-head"></tr>
        <tr mat-row *matRowDef="let row; columns: addActionsColumn(objectKeys(columnHeader));" class="bciti-element-row"></tr>
    </table>
    <div class="paginator-wrap">
        <mat-paginator
            class="pagniator"
            [length]="length"
            [pageSizeOptions]="[5, 10, 25, 50]"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            showFirstLastButtons
            (page)="pageChange($event)"
        ></mat-paginator>
    </div>
</section>